module.exports = __webpack_public_path__ + "static/67-8cbe07fdb3abb0998386d44ef108c3b6.png";